import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnChanges, OnInit, SimpleChanges, ViewEncapsulation, inject, input, output } from '@angular/core';
import {Chat, ChatParticipante, Pagination} from "@cdk/models";
import { FormBuilder, FormGroup, Validators, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { ChatMensagemHeaderComponent } from '../chat-mensagem-header/chat-mensagem-header.component';

import { MatToolbar, MatToolbarRow, MatIcon, MatAutocompleteTrigger, MatIconButton, MatProgressSpinner, MatMenuTrigger, MatMenu, MatMenuItem } from '@cdk/angular/material';
import { CdkUsuarioAutocompleteComponent } from '../../../../../@cdk/components/usuario/cdk-usuario-autocomplete/cdk-usuario-autocomplete.component';
import { MatError } from '@angular/material/form-field';
import { InfiniteScrollDirective } from 'ngx-infinite-scroll';
import { ChatImagemComponent } from '../chat-imagem/chat-imagem.component';
import { SortByDatePipe } from '../../../../../@cdk/pipes/sort-by-date.pipe';

@Component({
    selector: 'chat-participantes-list',
    templateUrl: './chat-participantes-list.component.html',
    styleUrls: ['./chat-participantes-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    imports: [ChatMensagemHeaderComponent, MatToolbar, MatToolbarRow, FormsModule, ReactiveFormsModule, MatIcon, MatAutocompleteTrigger, CdkUsuarioAutocompleteComponent, MatIconButton, MatProgressSpinner, MatError, InfiniteScrollDirective, ChatImagemComponent, MatMenuTrigger, MatMenu, MatMenuItem, SortByDatePipe]
})
export class ChatParticipantesListComponent implements OnInit, OnChanges
{
    private _formBuilder = inject(FormBuilder);
    private _changeDetectorRef = inject(ChangeDetectorRef);

    readonly chat = input<Chat>(null);

    readonly chatParticipanteList = input<ChatParticipante[]>([]);

    readonly errors = input<any>(null);

    readonly saving = input<boolean>(false);

    readonly loading = input<boolean>(false);

    readonly fecharHandler = output();

    readonly chatFormHandler = output<Chat>();

    readonly chatParticipantesHandler = output<Chat>();

    readonly adicionarParticipanteHandler = output<ChatParticipante>();

    readonly tornarAdministradorHandler = output<ChatParticipante>();

    readonly removerParticipanteHandler = output<ChatParticipante>();

    readonly excluirChatHandler = output<Chat>();

    readonly scrollDownHandler = output();

    usuarioPagination: any = new Pagination();
    participanteForm: FormGroup = null;
    errorMessage: string = null;



    constructor()
    {
        this.participanteForm = this._formBuilder.group({
            usuario: [null, [Validators.required]]
        });

    }

    ngOnInit(): void
    {
    }

    fechar() : void
    {
        this.fecharHandler.emit();
    }

    chatParticipantes(chat: Chat) : void
    {
            this.chatParticipantesHandler.emit(chat);
    }

    chatForm(chat: Chat) : void
    {
        this.chatFormHandler.emit(chat);
    }

    adicionarParticipante(): void
    {
        this.checkUsuario();

        if (this.participanteForm.invalid || this.saving()) {
            return;
        }

        const chatParticipante = new ChatParticipante();

        chatParticipante.chat = this.chat();
        chatParticipante.usuario = this.participanteForm.get('usuario').value;
        chatParticipante.administrador = false;

        this.adicionarParticipanteHandler.emit(chatParticipante);
    }

    checkUsuario(): void
    {
        const value = this.participanteForm.get('usuario').value;
        if (!value || typeof value !== 'object') {
            this.participanteForm.get('usuario').setValue(null);
        }
    }

    tornarAdministrador(chatParticipante: ChatParticipante): void
    {
        this.tornarAdministradorHandler.emit(chatParticipante);
    }

    removerParticipante(chatParticipante: ChatParticipante): void
    {
        this.removerParticipanteHandler.emit(chatParticipante);
    }

    excluirChat(chat: Chat): void
    {
        this.excluirChatHandler.emit(chat);
    }

    ngOnChanges(changes: SimpleChanges): void
    {
        this.errorMessage = null;

        const chat = this.chat();
        if (changes['chat'] && chat && chat?.participantes?.length > 0) {
            this.usuarioPagination.filter = {
                'id' : 'notIn:' + chat.participantes
                    .map(chatParticipante => chatParticipante.usuario.id)
                    .join(',')
            }
        }

        const errors = this.errors();
        if (changes['chat'] && changes['saving'] && this.saving() === false && !errors) {
            this.participanteForm.reset();
        }

        if (errors && errors.status && errors.status === 422) {
            try {
                const data = JSON.parse(errors.error.message);
                const fields = Object.keys(data || {});
                this.errorMessage = fields.join(', ');
            } catch (e) {
                this.errorMessage = errors.error.message;
            }
        }

        this._changeDetectorRef.detectChanges();
    }

    scrollDown(): void
    {
        this.scrollDownHandler.emit();
    }

}
